export default {
    dashboard: {
        groupExposure: 'Group exposure',
        granularityBuckets: 'granularity: {granularity} · buckets: {buckets}',
        refreshing: 'Refreshing…',
        loadingAggregate: 'Loading aggregate…',
        loadError: "Couldn't load aggregate",
        noPositionData: 'No position data for {from} → {to}',
        noPositionDataHint: 'Lock contracts whose delivery falls in this range, then Refresh.',
        coverageShowing: 'Showing',
        coverageDaysFraction: '{days} of {requested} days',
        coverageWithData: 'with data',
        coverageRangeNote:
            'The selected range is {from} → {to}; days with no locked contracts or forecast are omitted from the time axis below.',
        selectContract: 'Select a contract from the left to view details',
    },
}
